import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { ProductGroupFormValues } from "../productGroupTypes"
import { FormikSwitch } from "../../../../../shared/components/forms/Formik"
import { Alert, Grid } from "@mui/material"

export function ProductGroupFormSettings() {
    return (
        <Grid container direction="column" gap={2}>
            <Grid item>
                <LocalizedStrict id="product-group-form-active-switch">
                    <FormikSwitch<ProductGroupFormValues> name="isActive">Active</FormikSwitch>
                </LocalizedStrict>
            </Grid>
            <Grid item>
                <LocalizedStrict id="product-group-form-pin-code-required-switch">
                    <FormikSwitch<ProductGroupFormValues> name="isLocked">PIN code required</FormikSwitch>
                </LocalizedStrict>
            </Grid>
            <Grid item>
                <LocalizedStrict id="product-group-form-pin-code-required-explanation">
                    <Alert severity="info">
                        Products in this group will require a staff PIN code to purchase. PIN code can be seen in device
                        details.
                    </Alert>
                </LocalizedStrict>
            </Grid>
        </Grid>
    )
}
